import { useEffect, useState } from "react";

import audio_icon from "../../assets/microphone_100.png";
import video_icon from "../../assets/film_100.png";
import file_icon from "../../assets/file_100.png";
import libheifInit from "libheif-js/libheif-wasm/libheif-bundle.js";

export const useAttachmentPreview = (attachments = []) => {
  const [convertedImages, setConvertedImages] = useState({});

  const isHeic = (att) =>
    att.file_name?.toLowerCase().endsWith(".heic") ||
    att.direct_url?.toLowerCase().endsWith(".heic");

  useEffect(() => {
    const convertHeicImages = async () => {
      const heicFiles = attachments.filter(isHeic);
      const converted = {};

      const libheif = await libheifInit();
      for (const att of heicFiles) {
        try {
          const response = await fetch(att.direct_url);
          if (!response.ok) throw new Error("Fetch failed: " + response.status);
          const buffer = await response.arrayBuffer();

          const decoder = new libheif.HeifDecoder();
          const data = decoder.decode(new Uint8Array(buffer));

          if (!data || data.length === 0) throw new Error("No images found in HEIF file");

          const image = data[0];
          const width = image.get_width();
          const height = image.get_height();

          const objectUrl = await new Promise((resolve, reject) => {
            const pixelData = {
              data: new Uint8ClampedArray(width * height * 4),
              width,
              height,
              colorSpace: "srgb",
            };

            image.display(pixelData, (displayResult) => {
              if (!displayResult) { reject(new Error("Failed to display HEIF image")); return; }

              const canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              canvas.getContext("2d").putImageData(
                new ImageData(new Uint8ClampedArray(displayResult.data), width, height),
                0, 0
              );

              canvas.toBlob(
                (blob) => {
                  if (!blob) { reject(new Error("Canvas toBlob failed")); return; }
                  resolve(URL.createObjectURL(blob));
                },
                "image/jpeg",
                0.8
              );
            });
          });

          converted[att.id] = objectUrl;
        } catch (err) {
          console.error("HEIC conversion failed:", att.file_name, err);
        }
      }

      setConvertedImages((prev) => ({ ...prev, ...converted }));
    };

    if (attachments.length) convertHeicImages();
  }, [attachments]);

  const getPreviewConfig = (att) => {
    switch (true) {
      case att.proof_type === "PHOTO":
        return {
          src: att.extra?.thumbnail_url,
          clickable: true,
        };

      case isHeic(att):
        return {
          src: convertedImages[att.id] || file_icon,
          clickable: true,
        };

      case att.proof_type === "VIDEO":
        return {
          src: video_icon,
          clickable: true,
        };

      case att.proof_type === "AUDIO":
        return {
          src: audio_icon,
          clickable: true,
        };

      default:
        return {
          src: file_icon,
          clickable: true,
        };
    }
  };

  const getModalPreviewSrc = (att) => {
    if (
      att.file_name?.toLowerCase().endsWith(".heic") ||
      att.direct_url?.toLowerCase().endsWith(".heic")
    ) {
      return convertedImages[att.id];
    }
    return att.direct_url;
  };

  return { getPreviewConfig, getModalPreviewSrc };

};
